import { render, staticRenderFns } from "./paper-view.vue?vue&type=template&id=20562c8e&scoped=true&"
import script from "./paper-view.vue?vue&type=script&lang=js&"
export * from "./paper-view.vue?vue&type=script&lang=js&"
import style0 from "./paper-view.vue?vue&type=style&index=0&id=20562c8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20562c8e",
  null
  
)

export default component.exports